import { render, staticRenderFns } from "./realtime_guardwitness_list.vue?vue&type=template&id=571ab606&scoped=true"
import script from "./realtime_guardwitness_list.vue?vue&type=script&lang=js"
export * from "./realtime_guardwitness_list.vue?vue&type=script&lang=js"
import style0 from "./realtime_guardwitness_list.vue?vue&type=style&index=0&id=571ab606&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571ab606",
  null
  
)

export default component.exports